class RequestException extends Error {
	request: Request
	response: Response
	requestPayload: any
	critical = false
	constructor(
		message: string,
		request: Request,
		response: Response,
		requestPayload?: any,
		critical = false
	) {
		super(message)
		this.request = request
		this.response = response
		this.requestPayload = requestPayload
		this.critical = critical
	}
}

export default RequestException
